import { render } from "./OnboardExistingCustomers.vue?vue&type=template&id=59b82a94&scoped=true"
const script = {}

import "./OnboardExistingCustomers.vue?vue&type=style&index=0&id=59b82a94&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b82a94"]])

export default __exports__